import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const NotFound = lazy(() => import('../../container/pages/404'));
const Profile = lazy(() => import('../../container/modules/profile/index.js'));
const Search = lazy(() => import('../../container/modules/search/Search'));
const SearchView = lazy(() => import('../../container/modules/search/SearchView'));
const Reprocess = lazy(() => import('../../container/modules/reprocess/Reprocess'));
const ReprocessView = lazy(() => import('../../container/modules/reprocess/ReprocessView'));
const GroupView = lazy(() => import('../../container/modules/search/GroupView'));
const HQView = lazy(() => import('../../container/modules/search/HQView.js'));
const BatchControlView = lazy(() => import('../../container/modules/search/BatchControlView'));
const ReportGeneration = lazy(() => import('../../container/modules/reports/report'));
const Variables = lazy(() => import('../../container/modules/settings/VariableManagement'));
const Operations = lazy(() => import('../../container/modules/settings/OperationsManagement'));
const DocumentInfo = lazy(() => import('../../container/modules/settings/DocumentInfoManagement.js'));
const DataFields = lazy(() => import('../../container/modules/settings/DataFields'));
const UserManagement = lazy(() => import('../../container/modules/settings/users/UserManagement'));
const AddUser = lazy(() => import('../../container/modules/settings/users/AddUser'));
const AuditTrail = lazy(() => import('../../container/modules/settings/auditTrail/AuditTrail.js'));
const AuditTrailView = lazy(() => import('../../container/modules/settings/auditTrail/AuditTrailView.js'));

function PagesRoute() {
  return (
    <Routes>
      <Route path="profile" element={<Profile />} />
      {/* <Route path="reprocess" element={<Reprocess />} />
      <Route path="reprocess/view" element={<ReprocessView />} /> */}
      <Route path="search" element={<Search />} />
      <Route path="search/view" element={<SearchView />} />
      <Route path="search/hq-search/view" element={<HQView />} />
      <Route path="search/group-search/view" element={<GroupView />} />
      <Route path="search/batch-control/view" element={<BatchControlView />} />
      <Route path="report-generation" element={<ReportGeneration />} />
      <Route path="variables" element={<Variables />} />
      <Route path="operations" element={<Operations />} />
      <Route path="document-info-mngmt" element={<DocumentInfo />} />
      <Route path="document-info-mngmt/view" element={<DataFields />} />
      <Route path="user-mngmt" element={<UserManagement />} />
      <Route path="user-mngmt/add-user" element={<AddUser />} />
      <Route path="audit-trail" element={<AuditTrail />} />
      <Route path="audit-trail/view" element={<AuditTrailView />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default PagesRoute;
